import './loading-spinner.scss';

const LoadingSpinner = () => {
  return <div className='loading-spinner' data-testid='loading-spinner'></div>;
};

export default LoadingSpinner;
